import { useId } from 'react'
import { Box } from '@mui/material'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import SearchRow from '@/components/SecondaryLeftNavigation/components/SearchRow'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import { CONNECTION_ROW_MENU_ITEMS } from '@/components/Settings/settingsTablePlaceholders'
import shared from '@/components/Settings/settingsShared.module.scss'
import ConnectionsDirectoryPanel from '@/components/Settings/SettingsPageContent/ConnectionsDirectoryPanel'
import { useConnectionsDirectoryModel } from '@/components/Settings/SettingsPageContent/useConnectionsDirectoryModel'

export default function ConnectionsDirectory() {
  const m = useConnectionsDirectoryModel()
  const connectionsHeadingId = useId()
  const connectionsIntro = getSettingsSectionIntro('connections-directory')
  return (
    <Box component="section" aria-labelledby={connectionsHeadingId} className={shared.connectionsSection}>
      {connectionsIntro ? (
        <SettingsSectionIntro headingId={connectionsHeadingId} lines={connectionsIntro} />
      ) : null}
      <Box className={shared.searchRowWrap}>
        <SearchRow value={m.query} onChange={m.setQuery} placeholder="Search connected apps" />
      </Box>
      <ConnectionsDirectoryPanel
        listEmpty={m.listEmpty}
        searchNoHits={m.searchNoHits}
        rows={m.filteredConnections}
        menuAnchor={m.menuAnchor}
        menuRowId={m.menuRowId}
        onOpenRowMenu={m.handleOpenRowMenu}
      />
      <FloatingMenuPopup
        open={Boolean(m.menuAnchor)}
        anchorEl={m.menuAnchor}
        onClose={m.handleCloseRowMenu}
        items={CONNECTION_ROW_MENU_ITEMS}
        onItemSelect={m.handleRowMenuSelect}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        menuListId="connection-row-actions-menu"
        menuListAriaLabel="Connection actions"
      />
    </Box>
  )
}
